import { useMemo } from "react";

import { ValidationRow } from "models";

import { locationColorMap as buildLocationColorMap } from "pages/admin/soilSight/utils/soilSightColors";

export const useValidationData = (rows: ValidationRow[]) => {
  const locations = useMemo(() => [...new Set(rows.map((r) => r.location))].sort(), [rows]);
  const rotations = useMemo(() => [...new Set(rows.map((r) => r.rotation))].sort(), [rows]);
  const scenarios = useMemo(() => [...new Set(rows.map((r) => r.scenario))], [rows]);
  const locationColorMap = useMemo(() => buildLocationColorMap(locations), [locations]);

  return { locations, rotations, scenarios, locationColorMap };
};
